export default __webpack_public_path__ + "static/media/vip11.dd707884.gif";